import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { SignInComponent } from '../sign-in/sign-in.component';
import { Router, Params, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-reset-password-link',
    templateUrl: './reset-password-link.component.html',
    styleUrls: ['./reset-password-link.component.scss'],
    standalone: false
})
export class ResetPasswordLinkComponent implements OnInit {
  token: any;

  constructor(public dialog: MatDialog, public router: Router, private route: ActivatedRoute) {
    this.route.queryParams
      .subscribe(
        (params: Params) => {
          this.token = params['token'];
        });
  }

  ngOnInit(): void {
      const dialogRef = this.dialog.open(ResetPasswordComponent, {
        disableClose: true,
        data: {
          token: this.token,
        }
      });
  }

}
